"use client"

import { ChevronIcon } from "@/app/icons/chevron"
import { FiltersIcon } from "@/app/icons/filters"
import { NftFiltersMoleculeReatom } from "@/app/nft/search/filters/store.reatom"
import { Trans } from "@lingui/react/macro"
import {
  Badge,
  Button,
  cn,
  useSidebar,
} from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"

export const CollectionSidebarTrigger = reatomComponent(() => {
  const { toggleSidebar, open } = useSidebar()
  const { appliedFiltersCount } = useMolecule(NftFiltersMoleculeReatom)
  const count = appliedFiltersCount()

  return (
    <Button
      variant="outline"
      onClick={toggleSidebar}
      className={cn("pl-[10px]", open && "pl-[8px]")}
    >
      {open ? (
        <ChevronIcon className="mr-[-2px] rotate-90 [&&]:h-3 [&&]:w-3" />
      ) : (
        <FiltersIcon />
      )}
      <Trans>Filters</Trans>
      {count ? (
        <Badge
          variant="secondary"
          className="mr-[-2px] p-1 text-foreground/60 text-xs"
        >
          {count}
        </Badge>
      ) : null}
    </Button>
  )
}, "CollectionSidebarTrigger")
